// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CaseHikky() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>メタバース霊園のNFT</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>メタバース・エンタメ</span>
            <span>ブロックチェーン事業開発</span>
          </div>
          <h1 className="cd-title">
            メタバース霊園の土地と遺品を、NFTで受け継げる仕組みに
          </h1>
          <p className="cd-client">メタバース事業会社</p>
          <div className="cd-img is-cover">
            <span className="cover-en">METAVERSE NFT</span>
            <span className="cover-ja">メタバース × NFT</span>
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                NFTのアイデアはあったが、要件定義と実装ができる体制がなかった。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>
                既存のVRアプリに組み込めるNFTのAPIを提供し、所有の移転にも対応。
              </p>
            </div>
            <div>
              <span>成果</span>
              <p>
                VR上の土地とデジタル遺品を、NFTとして所有・相続できる仕組みを実装。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              メタバース事業会社が支援する「メタバース霊園
              風の霊」のアプリで、VR上の土地やデジタル遺品をNFTとして持てる仕組みを実装しました。相続にも対応できるよう、ユーザー間で所有を移転する機能も追加しています。
            </p>
          </section>
          <section className="cd-sec">
            <h2>お客様の課題</h2>
            <ul className="cd-list">
              <li>NFTのアイデアはあったが、要件定義や実装ができなかった</li>
              <li>
                ブロックチェーンのサービス開発に実績のあるパートナーと進めたかった
              </li>
              <li>
                アプリは既存のベンダーが開発しているため、役割を切り分ける必要があった
              </li>
              <li>ユーザーにとって不便な使い心地にはしたくなかった</li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSの対応</h2>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">チーム体制</p>
                <h3 className="cd-ptitle">
                  ブロックチェーンに精通したメンバーで伴走
                </h3>
                <p>
                  ブロックチェーンに精通したメンバーをアサインし、要件定義から実装まで一緒に進めました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">サービス設計</p>
                <h3 className="cd-ptitle">VRの体験を崩さないNFT設計</h3>
                <p>
                  ユーザーの使い心地を崩さない形で、土地やデジタル遺品をNFTとして扱うサービス設計を行いました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">API提供</p>
                <h3 className="cd-ptitle">既存VRに組み込めるNFTのAPI</h3>
                <p>
                  既存のVRアプリに組み込めるNFTのAPIを提供し、ブロックチェーン開発の経験がないエンジニアでも実装できる形にしました。相続のための所有移転も追加で実装しています。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>成果</h2>
            <p>
              VR上の土地とデジタル遺品を、NFTとして所有し、受け継いでいける仕組みを実現しました。
            </p>
          </section>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
